import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const XIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.559534 17.4404L9 8.99994M9 8.99994L17.4405 0.559469M9 8.99994L0.559534 0.559469M9 8.99994L17.4405 17.4404" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

XIcon.displayName = 'XIcon';
